module.exports = __webpack_public_path__ + "media/components/assets/sujung_00-c18bbee686dad377d140ec15a71674bc.png";